import { render, staticRenderFns } from "./UploadQCert.vue?vue&type=template&id=bd88e1f6&scoped=true&"
import script from "./UploadQCert.vue?vue&type=script&lang=js&"
export * from "./UploadQCert.vue?vue&type=script&lang=js&"
import style0 from "./UploadQCert.vue?vue&type=style&index=0&id=bd88e1f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88e1f6",
  null
  
)

export default component.exports